import { change } from 'redux-form';
import { replace } from 'react-router-redux';

import * as types from './types';
import { loading, error, success } from 'State/actions';
import { resetDirty } from 'State/dirtyTracking/actions';
import { ReportGeneration } from 'Common/ObjectHelper';
import {
  CreateEditPurchaseOrderEnum,
  ManagePurchaseOrderEnum,
} from 'Common/FieldEnum';
import { CREATE_EDIT_PURCHASE_ORDER_FORM_NAME } from 'Common/FormEnum';
import { base64ToBlob } from 'Common/IEHelper';

export const getPurchaseOrderData = filtersOptions => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.PURCHASE_ORDER_LOADING, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'Order/FilterOrders',
        filtersOptions
      );
      dispatch(success(types.PURCHASE_ORDER_LIST, response.data.Data));
    } catch (err) {
      dispatch(error(types.PURCHASE_ORDER_ERROR, err));
    } finally {
      dispatch(loading(types.PURCHASE_ORDER_LOADING, false));
    }
  };
};

export const closePurchaseOrder = orderListArray => {
  return (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.PURCHASE_ORDER_LOADING_ONCLOSE, true));
    return new Promise(async (resolve, reject) => {
      try {
        const response = await MPWWebApi.postGenericInsertUpdate(
          'Order/CloseOrders',
          orderListArray
        );
        resolve({
          response,
          error: null,
        });
      } catch (err) {
        dispatch(error(types.PURCHASE_ORDER_ERROR, err));
      } finally {
        dispatch(loading(types.PURCHASE_ORDER_LOADING_ONCLOSE, false));
      }
    });
  };
};

export const checkAllRow = (checkAll, currentRows) => {
  return {
    type: types.PURCHASE_ORDER_CHECKALL_ITEMS_DATA,
    payload: { checkAll, currentRows },
  };
};

export const checkCurrentRow = item => {
  return {
    type: types.PURCHASE_ORDER_UPDATE_ITEMS_DATA,
    payload: item,
  };
};
export const getPODetail = model => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.EDIT_PO_WO_LOADING, true));

    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        `Order/GetPOItems`,
        model
      );
      dispatch(success(types.EDIT_PO_WO_DETAIL, response.data.Data));
    } catch (ex) {
      dispatch(error(types.EDIT_PO_WO_LOADING_ERROR, ex));
    } finally {
      dispatch(loading(types.EDIT_PO_WO_LOADING, false));
    }
  };
};
export const getPOItems = (model, itemList) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.EDIT_PO_WO_ITEMS_LOADING, true));

    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        `Order/GetItemsToAddInPO`,
        model
      );
      dispatch(success(types.EDIT_PO_WO_ITEMS, response.data.Data));
      if (itemList && itemList.length) {
        dispatch(reorderItemList(itemList));
      }
    } catch (ex) {
      dispatch(error(types.EDIT_PO_WO_ITEMS_LOADING_ERROR, ex));
    } finally {
      dispatch(loading(types.EDIT_PO_WO_ITEMS_LOADING, false));
    }
  };
};
export const reorderItemList = items => {
  return {
    type: types.RE_ORDER_PO_WO_ITEM_LIST,
    payload: items,
  };
};
export const savePOWO = (model, resetScroll) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.SAVE_PO_WO_LOADING, true));
    resetScroll();

    model = {
      ...model,
    };

    try {
      await MPWWebApi.postGenericInsertUpdate('Order/WritePO', model);
      dispatch(resetDirty());
      dispatch(success(types.SAVE_PO_WO_SUBMIT));
      dispatch(replace('/managepurchaseorder'));
    } catch (ex) {
      dispatch(error(types.SUBMIT_PO_WO_DETAIL_ERROR), ex);
    } finally {
      dispatch(loading(types.SAVE_PO_WO_LOADING, false));
    }
  };
};

export const getPurchaseOrderPrintData = filterData => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.PURCHASE_ORDER_PRINT_LOADING, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'Order/PrintOrders',
        filterData
      );
      if (response.data.Data) {
        const data = response.data.Data;
        data[ManagePurchaseOrderEnum.BOPrintResult] &&
        ReportGeneration(
          data[ManagePurchaseOrderEnum.BOPrintResult],
          'BO Report'
        );
        data[ManagePurchaseOrderEnum.POPrintResult] &&
        ReportGeneration(
          data[ManagePurchaseOrderEnum.POPrintResult],
          'PO Report'
        );
        data[ManagePurchaseOrderEnum.WOPrintResult] &&
        ReportGeneration(
          data[ManagePurchaseOrderEnum.WOPrintResult],
          'WO Report'
        );
        data[ManagePurchaseOrderEnum.KOPrintResult] &&
        ReportGeneration(
          data[ManagePurchaseOrderEnum.KOPrintResult],
          'KO Report'
        );
      }
    } catch (err) {
      dispatch(error(types.PURCHASE_ORDER_PRINT_ERROR, err));
    } finally {
      dispatch(loading(types.PURCHASE_ORDER_PRINT_LOADING, false));
    }
  };
};

export const clearPurchaseOrderError = () => {
  return {
    type: types.CLEAR_PURCHASE_ORDER_ERROR,
  };
};

export const emptyItemList = () => {
  return {
    type: types.EDIT_PO_WO_ITEMS,
    payload: [],
  };
};

export const emptyEditObject = () => {
  return {
    type: types.EDIT_PO_WO_DETAIL,
    payload: null,
  };
};

export const clearInvalidPreviewData = data => {
  return async dispatch => {
    dispatch(
      change(
        CREATE_EDIT_PURCHASE_ORDER_FORM_NAME,
        CreateEditPurchaseOrderEnum.POItemDetails,
        data
      )
    );
  };
};
export const clearPOWOSubmitError = () => {
  return {
    type: types.CLEAR_PO_WO_ERROR_SUCCESS,
  };
};

export const getEleFileData = poIds => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.PURCHASE_ORDER_LOADING, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'Order/GetElectronicFiles',
        { ReceiptIds: poIds }
      );
      dispatch(
        success(
          types.PURCHASE_ORDER_ELE_FILE_DOWNLOAD_SUCCESS,
          response.data.Data.Message
        )
      );
      response.data.Data &&
      response.data.Data.ElectornicFiles &&
      response.data.Data.ElectornicFiles.forEach(data => {
        let fileName = data.FileName;
        let fileData = data.Stream;
        eleFileGeneration(fileName, fileData);
      });
    } catch (error) {
      dispatch({
        type: types.PURCHASE_ORDER_ERROR,
        payload: error,
      });
    } finally {
      dispatch(loading(types.PURCHASE_ORDER_LOADING, false));
    }
  };
};

const eleFileGeneration = (fileName, fileData) => {
  let blob = base64ToBlob(fileData, 'application/octet-stream');
  let URL = window.URL || window.webkitURL || window.mozURL;
  let downloadUrl = URL.createObjectURL(blob);
  if (fileName) {
    let a = document.createElement('a');
    if (typeof a.download === 'undefined') {
      window.location = downloadUrl;
    } else {
      a.href = downloadUrl;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  } else {
    window.location = downloadUrl;
  }
};

export const emptyEleFileDownloadSuccessMessage = () => {
  return {
    type: types.PURCHASE_ORDER_ELE_FILE_DOWNLOAD_SUCCESS,
    payload: '',
  };
};
export const getPurchaseOrderReceiptPrint = filterData => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.PURCHASE_ORDER_PRINT_LOADING, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'Receipt/GetReceiptPrint',
        filterData
      );
      if (response.data.Data) {
        const data = response.data.Data;
        if (data[ManagePurchaseOrderEnum.WOPOPrintResult]) {
          ReportGeneration(
            data[ManagePurchaseOrderEnum.WOPOPrintResult],
            'Purchase Order WOPO Report'
          );
        }
        if (data[ManagePurchaseOrderEnum.KOPrintResult]) {
          ReportGeneration(
            data[ManagePurchaseOrderEnum.KOPrintResult],
            'Purchase Order KO Report'
          );
        }
      }
    } catch (err) {
      dispatch(error(types.PURCHASE_ORDER_PRINT_ERROR, err));
    } finally {
      dispatch(loading(types.PURCHASE_ORDER_PRINT_LOADING, false));
    }
  };
};
export const managePOWOReceiptDelete = id => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.DELETE_PO_WO_RECEIPT_LOADING, true));
      const response = await MPWWebApi.postGenericInsertUpdate(
        'Order/Delete',
        id
      );
      return {
        response,
        error: null,
      };
    } catch (error) {
      dispatch(error(types.DELETE_PO_WO_RECEIPT_LOADING_ERROR, error));
    } finally {
      dispatch(loading(types.DELETE_PO_WO_RECEIPT_LOADING, false));
    }
  };
};
export const setToDateMin = payload => {
  return {
    type: types.SET_TO_DATE_MIN,
    payload,
  };
};
export const setFromDateMax = payload => {
  return {
    type: types.SET_FROM_DATE_MAX,
    payload,
  };
};

export const getSiteList = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.FETCHING_SITES, true));

    try {
      const response = await MPWWebApi.getGeneric(`Sitemaster`);

      dispatch({
        type: types.PURCHASE_ORDER_SITE_LIST,
        payload: response.data.Data ? response.data.Data : [],
      });
      dispatch(loading(types.FETCHING_SITES, false));
    } catch (error) {
      dispatch({
        type: types.FETCH_ALL_SITE_ERROR,
        payload: error,
      });
      dispatch(loading(types.FETCHING_SITES, false));
    }
  };
};


// WEBPACK FOOTER //
// ./src/pages/inventory/managepurchaseorder/state/managePurchasseOrder/actions.js